<template>
  <div v-if="!isOpenDeps" class="setting-container">
    <div class="camera-setting-item">
      <div class="flex items-center justify-between w-full">
        <div>{{ $t('camstudy.cameraSetting.transition') }}</div>
        <GrmToggle :is-checked.sync="isCameraTransition" @onChange="toggleTransitionCamera" />
      </div>
    </div>
    <div class="camera-setting-item">
      <div class="flex items-center justify-between w-full">
        <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.faceMask') }}</p>
        <GrmToggle :is-checked.sync="coverFace" @onChange="onFaceMaskChangeHandler"/>
      </div>
    </div>
    <div class="camera-setting-item">
      <div class="flex items-center justify-between w-full" @click="onOpenDeps">
        <div>{{ $t('camstudy.cameraSetting.blur.title') }}</div>
        <div class="color-999 flex items-center">
          <div>{{ isCameraBlurActive ? $t('camstudy.cameraSetting.blur.on') : $t('camstudy.cameraSetting.blur.off')}}</div>
          <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" />
        </div>
      </div>
      <div class="item-description">{{ $t('camstudy.cameraSetting.blur.text') }}</div>
    </div>
  </div>
  <div v-else class="setting-container">
    <div class="camera-setting-item">
      <div class="flex items-center justify-between w-full">
        <div>{{ $t('camstudy.cameraSetting.blur.title') }}</div>
        <GrmToggle :is-checked.sync="isCameraBlurActive" :disabled="!isBlurEnabled" @onDisabled="onDisabled" />
      </div>
      <div class="item-description">{{ $t('camstudy.cameraSetting.blur.text') }}</div>
    </div>
    <div v-if="isCameraBlurActive" class="camera-setting-item">
      <div class="flex items-center gap-3 w-full">
        <div class="shrink-0">{{ $t('camstudy.cameraSetting.blur.height') }}</div>
        <input type="range" min="0" max="100" class="custom-slider"
               v-model="blurVideo.height" @input="setBlurVideo" :style="{'--slider-progress': `${blurVideo.height}%`}" />
        <div class="shrink-0 color-999">{{ blurVideo.height }}%</div>
      </div>
    </div>
    <div v-if="isCameraBlurActive" class="camera-setting-item">
      <div class="flex items-center gap-3 w-full">
        <div class="shrink-0">{{ $t('camstudy.cameraSetting.blur.power') }}</div>
        <input type="range" min="0" :max="blurVideo.blurMaxSize" class="custom-slider"
               v-model="blurVideo.blurSize" @input="setBlurVideo" :style="{'--slider-progress': `${(blurVideo.blurSize / blurVideo.blurMaxSize) * 100}%`}" />
        <div class="shrink-0 color-999">{{ ((blurVideo.blurSize / blurVideo.blurMaxSize) * 100) }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmToggle from "@/components/Common/toggle/GrmToggle.vue";
import {mapActions, mapGetters} from "vuex";
import {debounce} from "lodash";

export default {
  name: "CameraScreenSetting",
  components: {GrmToggle},
  props: {
    isOpenDeps: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      isCameraTransition: true,
      isCameraBlurActive: false,
      blurVideo: {
        isOpen: false,
        height: 0,
        blurSize: 0,
        blurMaxSize: 10
      },
      isBlurEnabled: false,
      isFaceMaskEnabled: false,
      coverFace: false,
    }
  },
  watch: {
    isCameraBlurActive(){
      if(this.isCameraBlurActive === false){
        this.blurVideo.height = 0;
        this.blurVideo.blurSize = 0;
        this.setBlurVideo();
      }
    }
  },
  computed: {
    ...mapGetters('camstudy', ['isUserTrialEnabledBy', 'personalSetting'])
  },
  async created() {
    await this.initVideoBlur();
    await this.initVideoTransition()
    if(this.personalSetting.autoBrightnessTerm === undefined){
      await this.getPersonalSetting();
    }
    const setting = this.personalSetting;
    this.autoBrightnessTerm = setting.autoBrightnessTerm;
    this.fixedScreen = this.statusToBoolean(setting.fixedScreen);
    this.isBlurEnabled = this.isUserTrialEnabledBy('BLUR')
    this.isFaceMaskEnabled = this.isUserTrialEnabledBy('FACE_MASK')
    if (!this.isFaceMaskEnabled) {
      this.coverFace = false
    } else {
      this.coverFace = this.statusToBoolean(setting.coverFace);
    }
  },
  methods: {
    ...mapActions('camstudy', ['getVideoBlurOptions', 'changeVideoBlur', 'modifyPersonalSetting', 'getPersonalSetting']),
    ...mapActions('call', [
      'getLocalDeviceSetting'
    ]),
    async initVideoTransition () {
      const setting = await this.getLocalDeviceSetting();
      this.isCameraTransition = !!setting.video.usePreviewMirror
    },
    async initVideoBlur () {
      const options = await this.getVideoBlurOptions();

      if(!options || options.percent <= 0 || options.blurSize <= 0){
        return;
      }

      let {percent, blurSize} = options;
      this.isCameraBlurActive = true;
      this.blurVideo.initBlurOptions = {
        height: percent * 100,
        blurSize
      };
      Object.assign(this.blurVideo, this.blurVideo.initBlurOptions);
      this.setBlurVideo();
      // const track = this.getPreviewVideoTrack();
      // track?.GrmTrack?.setPipeOptions('BlurFilter', {
      //   percent, blurSize
      // });

      // const el = this.$refs.videoBlurControl;
      // const initValue = {
      //   maxWidth: el.parentElement.offsetWidth,
      //   maxHeight: el.parentElement.offsetHeight,
      // }
      // let left = initValue.maxWidth * (blurSize / 15);
      // let top = initValue.maxHeight * percent;
      // Object.assign(el.style, {
      //   left: `${left}px`,
      //   top: `${top}px`,
      // });
    },
    onClickBlurFilterButton (e) {
      e.preventDefault();

      const el = e.target;
      const style = getComputedStyle(el);
      const initValue = {
        maxWidth: el.parentElement.offsetWidth,
        maxHeight: el.parentElement.offsetHeight,

        startLeft: parseInt(style.left) || 0,
        startTop: parseInt(style.top) || 0,

        startX: e.clientX ?? e.touches?.[0]?.clientX,
        startY: e.clientY ?? e.touches?.[0]?.clientY,
      };

      let blurOptions;

      const moveListener = e => {
        e.preventDefault();
        e.stopPropagation();

        const clientX = e.clientX ?? e.touches?.[0]?.clientX;
        const clientY = e.clientY ?? e.touches?.[0]?.clientY;
        if (clientX == null || clientY == null) return;

        let gapX = e.clientX - initValue.startX;
        let gapY = e.clientY - initValue.startY;

        let left = Math.max(initValue.startLeft + gapX, 0);
        if(left > initValue.maxWidth){
          left = initValue.maxWidth;
        }
        el.style.left = `${left}px`;

        let top = Math.max(initValue.startTop + gapY, 0);
        if(top > initValue.maxHeight){
          top = initValue.maxHeight;
        }
        el.style.top = `${top}px`;

        let blurSize = left / initValue.maxWidth;
        blurSize = parseInt(blurSize * 15);

        let percent = top / initValue.maxHeight;
        if(percent <= 0.05){
          percent = 0;
        }
        blurOptions = {
          percent: Math.max(percent, 0),
          blurSize
        };

        const track = this.getPreviewVideoTrack();
        if (track?.GrmTrack) {
          track.GrmTrack.setPipeOptions('BlurFilter', blurOptions);
        }
      };

      const upListener = e => {
        if(blurOptions){
          this.changeVideoBlur({...blurOptions});
        }
        el.releasePointerCapture(e.pointerId);
        el.removeEventListener('pointermove', moveListener);
        el.removeEventListener('pointerup', upListener);
        el.removeEventListener('pointercancel', upListener);
      };

      el.setPointerCapture(e.pointerId);
      el.addEventListener('pointermove', moveListener, false);
      el.addEventListener('pointerup', upListener, {once: true});
      el.addEventListener('pointercancel', upListener, {once: true});
    },
    toggleBlurVideo () {
      this.blurVideo.isOpen = !this.blurVideo.isOpen;
      if(this.blurVideo.isOpen){
        this.initVideoBlur();
      }
    },
    cancelBlurVideo () {
      this.blurVideo.isOpen = false;
      Object.assign(this.blurVideo, this.blurVideo.initBlurOptions);
      this.setBlurVideo();
    },
    setBlurVideo () {
      const {height, blurSize, blurMaxSize} = this.blurVideo;

      const blurOptions = {
        percent: Math.max(height / 100, 0),
        blurSize
      };
      
      const track = this.getPreviewVideoTrack();
      if (!track || !track.GrmTrack) {
        console.warn('No GrmTrack available for blur filter');
        return;
      }
      
      try {
        track.GrmTrack.setPipeOptions('BlurFilter', blurOptions);
        this.changeVideoBlur(blurOptions);
      } catch (error) {
        console.error('Failed to set blur options:', error);
      }
    },
    saveBlurVideo () {
      const {height, blurSize} = this.blurVideo;
      this.changeVideoBlur({
        percent: Math.max(height / 100, 0),
        blurSize
      });
    },
    getPreviewVideoTrack () {
      // 1. 기존 video 엘리먼트 접근 시도
      const video = this.$parent.$refs['preview_video'];
      if (video?.srcObject) {
        return video.srcObject.getVideoTracks()[0];
      }
      
      // 2. Canvas 렌더링 시 부모의 currentGrmTrack 사용 (fallback)
      return this.$parent.currentGrmTrack;
    },
    toggleTransitionCamera() {
      this.$emit('toggleTransitionCamera', this.isCameraTransition)
    },
    onOpenDeps(){
      this.$emit('onOpenDeps');
    },
    onDisabled(){
      this.$camsAlert({
        text: this.$t('camstudy.freeRoom.featureAlert'),
        onlyOk: true
      })
    },
    onFaceMaskChangeHandler() {
      if (!this.isFaceMaskEnabled) {
        this.$camsAlert({
          text: this.$t('camstudy.freeRoom.featureAlert'),
          onlyOk: true
        });
        this.coverFace = false
      }

      this.changeStatus()
    },
    changeStatus: debounce(async function() {
      const track = this.getPreviewVideoTrack();
      const trackApp = track?._grm_tg;
      if(!trackApp) return;

      // preview 미리보기
      if(!this.coverFace){
        trackApp.setFaceDrawType(null);
      }else{
        const faceImage = require(`@/assets/roomType/lms/img/emoti-img/grm-face-01.svg`);
        await trackApp.pipeThrough('FaceDetector', {
          drawType: 'faceImage',
          faceImage,
        });
        await trackApp.setFaceImage(faceImage);
      }

      await this.modifyPersonalSetting({
        autoBrightnessTerm: this.autoBrightnessTerm,
        fixedScreen: this.booleanToStatus(this.fixedScreen),
        coverFace: this.booleanToStatus(this.coverFace),
      });
    }, 100),
    booleanToStatus(boolean) {
      return boolean ? 'on' : 'off';
    },
    statusToBoolean(status) {
      return status === 'on';
    },
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .setting-container {
    @media(orientation: portrait) {
      height: calc(100dvh - 100vw - 124px - 50px + 20px);
    }
    @media(orientation: landscape) {
      height: calc(100dvh - 121px);
    }
    overflow-y: scroll;
  }
}
.camera-setting-item{
  padding: 12px 6px;
  color: white;
  font-size: 14px;
}
.item-description{
  color: #999;
  height: 22px;
  font-size: 11px;
}
.custom-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.20);
  outline: none;
  position: relative;
}
.custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.custom-slider::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.custom-slider::before {
  content: '';
  position: absolute;
  height: 100%;
  background: #2978f0;
  border-radius: 20px;
  z-index: 1;
  left: 0;
  top: 0;
  width: var(--slider-progress, 60%);
  pointer-events: none;
}
.shrink-0{
  flex-shrink: 0;
}
.color-999{
  color: #999;
}
</style>